export default {
  name: "ProviewImg",
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    url: {
      type: String,
      default() {
        return "";
      }
    },
    title: {
      type: String,
      default() {
        return $t("bgh7yl4", "图片预览");
      }
    }
  },
  data() {
    return {
      modal: {
        visible: false
      }
    };
  },
  watch: {
    visible(val) {
      this.modal.visible = val;
    }
  }
};